import { render } from "./Player.vue?vue&type=template&id=f7b0ea8a"
import script from "./Player.vue?vue&type=script&lang=js"
export * from "./Player.vue?vue&type=script&lang=js"
script.render = render

export default script